import { useTranslation } from 'react-i18next';
import Layout from '../../Layouts';

function About() {
  const { t } = useTranslation();

  return (
    <Layout>
      <div className="flex flex-col justify-center items-center bg-white p-2 mt-5 relative">
        <div id="resim" className="hidden md:block w-full absolute top-[-20px]">
          <img
            src="/images/general/about.jpg"
            alt="About"
            className="w-full h-[200px] object-cover rounded-lg border-4 border-gray-200 shadow-inner opacity-20 transition duration-300 ease-in-out transform hover:scale-105 hover:opacity-20"
          />
        </div>

        <div
          id="abaout"
          className="flex flex-col justify-center items-center mt-3 md:mt-[200px] p-5">
          <div className="space-y-4">
            <p className="text-lg">
              <strong className="font-semibold text-gray-900">
                ALTUNTUR COMPANY
              </strong>
            </p>
            <p className="text-base text-gray-700 leading-relaxed">
              {t('AboutTanitim1')}
            </p>
            <ul className="list-disc list-inside text-base text-gray-700 space-y-1">
              {[
                'Bağdat',
                'Basra',
                'Erbil',
                'Süleymaniye',
                'Kerkük',
                'Duhok',
                'Zaho',
                'Kerbela',
                'Hille',
                'Necef',
                'Samara',
                'Tikrit',
                'Akre',
                'Divaniye',
                'Diyana',
                've diğer bölgeler...'
              ].map((city, index) => (
                <li key={index}>{city}</li>
              ))}
            </ul>
            <p className="text-base text-gray-700 leading-relaxed">
              <strong className="font-semibold text-gray-900">ALTUNTUR</strong>{' '}
              {t('AboutTanitim2')}
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default About;
